import React, { Fragment } from "react";
import { Card, Col } from 'react-bootstrap';
import '../../../../styles/balanco.scss'
import Moment from 'moment';

const Ouvidoria = (props) => {

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const dataCad = Moment(props.requisicao.dataCad).utc(false).format("DD [de] MMMM [de] YYYY")
    const dataAtualiza = Moment(props.requisicao.dataAtualiza).utc(false).format("DD [de] MMMM [de] YYYY")
    const dataPrev = Moment(props.requisicao.dataPrevisao).utc(false).format("DD [de] MMMM [de] YYYY")


    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>Requisição nº: {props.requisicao._id.substring(0, Math.ceil(props.requisicao._id.length / 2))}</h5></Card.Header>
                    <Card.Body>
                        {props.requisicao.grauSigilo ?
                            <p>Grau do Sigilo: {props.requisicao.grauSigilo}</p>
                            : null}
                        {props.requisicao.justificativa ?
                            <p>Fundamentação do Sigilo: {props.requisicao.justificativa}</p>
                            : null}
                        <p>Situação: {props.requisicao.situacao}</p>
                        <p>Data da Requisição: {dataCad}</p>
                        <p>Data da última atualização: {dataAtualiza}</p>
                        {props.requisicao.dataPrevisao ?
                            <p>Data prevista para resposta: {dataPrev}</p>
                            : null}

                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Ouvidoria;